import * as React from 'react';
import { forwardRef } from 'react';

var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgShaprLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 456.4 510.2",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M287.3,223.9l0-62.1l-59.1-34.2l-100.6,58.2v76.7l41.5,23.9v62.1l59.1,34.2l100.6-58.2v-76.7L287.3,223.9z  M235.8,147.9l37.5,21.6v46.3L235.8,194V147.9z M220.5,362.4L183,340.7v-46.3l37.5,21.8V362.4z M228.2,304.3l-85.1-49.2l85.1-49.2 l85,49.2L228.2,304.3z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShaprLogo);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=ShaprLogo.svg.js.map
